import { Routes } from '@models/route';
import { lazy } from 'react';

const QuestionnairePreview = lazy(() =>
  import('@pages/questionnaires/QuestionnairePreview').then((p) => ({
    default: p.default
  }))
);

export const PreviewRoutes: Routes = [
  {
    path: 'preview/:id',
    component: QuestionnairePreview
  }
];
